import { styled } from "@mui/material/styles";

const StyledInventoryAction = styled("div")(
  ({ theme }) => `
    max-width: 100%;
    background-color: ${theme.palette.customColor.white};
    margin-top: 16px;
    padding-top: 24px;
    padding-bottom: 12px;

    @media (max-width: 600px){
    background-color: transparent;
    }

    .main-container-table {
    padding-top:10px;
        min-height: 300px;
        display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;}

    .main-title {
        font-family: 'Lexend', sans-serif;
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        color: ${theme.palette.primary.main};
        padding-left: 24px;

        @media (max-width: 600px){
        padding-left: 0px;
        font-size: 16px;
        }
    }

    .loader-container { 
    margin-top: 16px;
margin-left: 2%;
 width: 96%;
  height: 300px;
   position: relative;}

.view-all-btn {
text-transform: none;
font-family: Lexend;
font-weight: 400;
font-size: 14px;
text-decoration: underline;
color: ${theme.palette.primary.main};
}

.icon-no-data{
font-size: 30px;
}

.head-container{
display: flex;
justify-content: space-between;
align-items: center;
padding-right: 24px;

@media (max-width: 600px){
padding-right: 0px;
}
}
.action-btn {
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 5px 10px;
  border-radius: 0px;
}
.action-text {
  font-family: Lexend;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-transform: none;
  color: ${theme.palette.customColor.white};
}  

`
);

export default StyledInventoryAction;
